const RECEPCIONES = (state, recepciones) => {
    state.recepciones = recepciones;
};

const CONTENEDORES = (state, contenedores) => {
    state.contenedores = contenedores;
};

const RUTAS = (state, rutas) => {
    state.rutas = rutas;
};

export default {
    RECEPCIONES,
    CONTENEDORES,
    RUTAS
};